'use client';
import 'primeicons/primeicons.css';                         // Iconos de PrimeReact
import 'primeflex/primeflex.css';                           // Utilidades de PrimeFlex
import 'primereact/resources/primereact.min.css';           // Estilos base de PrimeReact
import '../styles/globals.css';                             // Estilos globales personalizados
import '../styles/demo/Demos.scss';                         // Estilos personalizados
import '../styles/layout/layout.scss';
import '../styles/crud/crud.css';
import "@fullcalendar/common/main.css";
import '../styles/fullcanlendar.min.css';
// import "@fullcalendar/daygrid/main.css";
// import "@fullcalendar/timegrid/main.css";
// import "@fullcalendar/list/main.css";

import React, { useEffect, useState } from 'react';
import { LayoutProvider } from '../layout/context/layoutcontext';
import { PrimeReactProvider } from 'primereact/api';
import Head from 'next/head';
import { MenuProvider } from '@/layout/context/menucontext';
import { getToLocalStorage, saveToLocalStorage } from '@/utils/utils';
import { useRouter } from 'next/router';
// import 'primereact/resources/themes/lara-light-indigo/theme.css';

interface RootLayoutProps {
    children: React.ReactNode;
}

interface RootLayoutProps {
    Component: React.ComponentType<any>;
    pageProps: any;
}

// Load layout configuration from local storage
function loadLayoutConfig() {
    const storedLayoutConfig = getToLocalStorage('layout-config');
    if (storedLayoutConfig) {
        return storedLayoutConfig;
    } else {
        return { theme: 'lara-light-indigo', colorScheme: 'light' };
    }
}

function RootLayout({ Component, pageProps }: RootLayoutProps) {
    const [layoutConfig, setLayoutConfig] = useState(loadLayoutConfig());
    const router = useRouter();

    useEffect(() => {
        setLayoutConfig(loadLayoutConfig());
    }, [router.pathname]);

    return (
        <>
            <Head>
                <title>Pericles EmnaIIT</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link id="theme-css" rel="stylesheet" href={`/themes/${layoutConfig.theme}/theme.css`} />
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <div className="app-container bg-light">
                    <MenuProvider>
                        <PrimeReactProvider>
                            <LayoutProvider>
                                <Component {...pageProps} />
                            </LayoutProvider>
                        </PrimeReactProvider>
                    </MenuProvider>
            </div>
        </>
    );
}

export default RootLayout;
